/**
 * @description Directive to allow only digit on input field
 * @example
 * <input type="tel" maxlength="5" minlength="5" only-digits>
 */
angular.module('mean').directive('onlyDigits', function() {
    return {
        restrict: 'A',
        require: '?ngModel',
         // create linking function and pass in our NgModelController as a 4th argument
        link: function (scope, element, attrs, modelCtrl) {
            modelCtrl.$parsers.push(function (inputValue) {
                if (inputValue === undefined) return '';
                var transformedInput = inputValue.replace(/[^0-9]/g, '');
                if (transformedInput !== inputValue) {
                    modelCtrl.$setViewValue(transformedInput);
                    modelCtrl.$render();
                }
                return transformedInput;
            });
        }
    };
});



// WEBPACK FOOTER //
// ./commonUtil/onlyDigit.js